export async function getUserFromDB() {
  try {
    const res = await fetch("/api/user/me");

    if (!res.ok) {
      // 401/403 are expected when signed out or the session is stale — treat as
      // "no user", not an error. Only warn on unexpected statuses, and use
      // console.warn so it doesn't trip the Next.js dev error overlay.
      if (res.status !== 401 && res.status !== 403) {
        console.warn(`Failed to fetch user: ${res.status} ${res.statusText}`);
      }
      return null;
    }

    return res.json();
  } catch (error) {
    console.warn("Error fetching user:", error);
    return null;
  }
}
